import { EpimsBaseEntityDto } from './epim-base.dto';
export class NetworkDto extends EpimsBaseEntityDto {

  NetworkId: string;
 
  NetworkName: string;
 
  SubscriptionUserId: string;
  length: number;
  }
